import { createBrowserHistory } from 'history';

// TODO: Fix this typing up properly.
//  Something weird going on with typing for history.
export const routerHistory = createBrowserHistory() as any;
